import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { DedupeTool } from "../components/DedupeTool";
import { RdBreadcrumb } from "../components/RdBreadcrumb";
import { RdExplainer } from "../components/RdExplainer";

export function RemoveDuplicateLinesPage() {
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <RdBreadcrumb />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.rd_h1()}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.rd_intro()}
          </p>
        </header>

        <DedupeTool />

        <RdExplainer
          howTo={m.rd_howto()}
          faqs={[
            { q: m.rd_faq1_q(), a: m.rd_faq1_a() },
            { q: m.rd_faq2_q(), a: m.rd_faq2_a() },
            { q: m.rd_faq3_q(), a: m.rd_faq3_a() },
            { q: m.rd_faq4_q(), a: m.rd_faq4_a() },
          ]}
        />

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
